import {
  type HistoryOptions,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { removeDrawerStateFromUrl } from '../../utils';

export function usePayoutDetailDrawer() {
  const [opts, set] = useQueryStates({
    payout: parseAsString,
  });

  return {
    opened: !!opts.payout,
    open: (id: string, type?: HistoryOptions) => {
      removeDrawerStateFromUrl();
      set(
        { payout: id },
        {
          history: type || 'push',
        }
      );
    },
    close: () => set(null),
    payoutId: opts.payout,
  };
}
